// pelanggan.service — validasi + anti-double (WA) + guard hapus. Port saveCust/custDelete v0.18.
import { currentUser } from '@core/session';
import { cleanText, wa62 } from '@domain/format';
import * as repo from './pelanggan.repo';

export interface CustForm {
  id: number | null; nama: string; kat: string; telpwa: string;
  lahir?: string; email?: string; kota?: string; alamat?: string; sumber?: string; catatan?: string;
}

/** Kembalikan id pelanggan (baru atau yang diubah) — pemanggil memakainya utk mencatat perekomendasi. */
export async function saveCust(f: CustForm): Promise<number> {
  const u = currentUser();
  if (!u) throw new Error('Sesi tidak valid.');
  const nama = cleanText(f.nama, 120);
  const kat = f.kat === 'Toko' ? 'Toko' : f.kat === 'User' ? 'User' : '';
  const wa = wa62(f.telpwa);
  if (!nama || !kat || !wa) throw new Error('Nama, kategori, dan nomor (WhatsApp) wajib diisi.');
  const dup = await repo.findByWA(wa);
  if (dup && dup.id !== f.id) throw new Error(`Nomor WA sudah dipakai pelanggan "${dup.nama}" — jangan buat double.`);

  const data: repo.CustInput = {
    nama, kat: kat as 'User' | 'Toko', telp: wa, wa,
    lahir: f.lahir || null, email: cleanText(f.email ?? '', 180), kota: cleanText(f.kota ?? '', 100),
    alamat: cleanText(f.alamat ?? '', 500), sumber: cleanText(f.sumber ?? '', 80), catatan: cleanText(f.catatan ?? '', 1000),
  };
  if (f.id) {
    // Ganti nomor pelanggan lama → simpan riwayat perubahan (port v0.18). Nomor lama tak hilang.
    const cur = await repo.getWaInfo(f.id);
    if (cur.wa && cur.wa !== wa) data.wa_history = [...cur.wa_history, { old: cur.wa, new: wa, by: u.nama, at: new Date().toISOString() }];
    await repo.updateCustomer(f.id, data);
    return f.id;
  }
  data.outlet = u.outlet ?? null;
  return repo.createCustomer(data);
}

export async function deleteCust(id: number): Promise<void> {
  const u = currentUser();
  if (!u || !['Owner', 'Manager'].includes(u.role)) throw new Error('Hanya Owner/Manager yang dapat menghapus pelanggan.');
  if ((await repo.ticketCount(id)) > 0) throw new Error('Pelanggan punya riwayat servis — tidak dapat dihapus.');
  await repo.removeCustomer(id);
}
